import React, { useEffect, useState } from "react";

const Features = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // API call
  useEffect(() => {
    fetch("https://api.ratnasworld.com/api/Products")
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }
        return response.json();
      })
      .then((result) => {
        setData(result);
        setLoading(false);
      })
      .catch((err) => {
        setError(err.message);
        setLoading(false);
      });
  }, []);

  if (loading) return <h3>Loading...</h3>;
  if (error) return <h3>Error: {error}</h3>;

  return (
    <div style={{ padding: "20px" }}>
      <h2>Products List</h2>
      <ul>
        {data.map((user) => (
          <li key={user.productid}>
            <strong>{user.productname}</strong> – {user.price}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Features;
